import { useTranslation } from "react-i18next"
import Button from "../formfields/Button"


type Props = {
    selectedButtonClass: 'primary' | 'white' | 'secondary' | 'gray'
    unSelectedButtonClass: 'primary' | 'white' | 'secondary' | 'gray'

}


function SwitchLanguage({
    selectedButtonClass,
    unSelectedButtonClass
}: Props) {


    const { i18n } = useTranslation()

    return <div
        className={`flex flex-row gap-1`}>
        <Button
            onClick={() => i18n.changeLanguage('en')}
            text={`English`}
            variant={i18n.language === 'en' ? selectedButtonClass : unSelectedButtonClass}
            size={'small'}
        />
        <Button
            onClick={() => i18n.changeLanguage('ar')}
            text={`عربي`}
            variant={i18n.language === 'ar' ? selectedButtonClass : unSelectedButtonClass}
            size={'small'}
        />
        <Button
            onClick={() => i18n.changeLanguage('es')}
            text={`Español`}
            variant={i18n.language === 'es' ? selectedButtonClass : unSelectedButtonClass}
            size={'small'}
        />
    </div>
}

export default SwitchLanguage